import React, { Component } from 'react';
import styled from 'styled-components';
import {
  BackButton,
  Button,
  Heading,
  CreateButton as DefaultCreateButton,
  HighlightedInput,
  ItemListItem,
  ItemListHeadingContainer,
  ItemListHeading,
  ItemListSubheading,
  ItemListActionContainer,
  Checkbox,
  Text, InputGroup, Label,
} from 'prospect-path-components';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import getVendorProducts from '../../actions/product-management/GetVendorProducts';
import { history } from '../../store';
import updateTeamProducts from '../../actions/product-management/UpdateTeamProducts';

const Container = styled.div`
    max-width: 25rem;
    margin-left: auto;
    margin-right: auto;
`;

const ImageContainer = styled.div`
    padding: 1.8rem 0;
`;

const ContainerBody = styled.div`
    padding-top: 20%;
`;

const CreateButton = styled(DefaultCreateButton)`
  background-color: white;
  padding-top: 1.5rem;
`;

const renderLoadingState = () => (
  <div>
    <Container>
      <ImageContainer>
        <img src="/images/logo.svg" />
      </ImageContainer>

      <ContainerBody>
        <Heading></Heading>

        <div>
        </div>

        <Button style={{ marginTop: '2rem' }} block color="primary">&nbsp;</Button>
      </ContainerBody>
    </Container>
  </div>
);

class TeamProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      createNewProduct: false,
      newProductName: '',
    };

    this.productIsSelected = this.productIsSelected.bind(this);
    this.productIsDisabled = this.productIsDisabled.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.getTeamId = this.getTeamId.bind(this);
    this.teamHasProduct = this.teamHasProduct.bind(this);
    this.handleCheckProduct = this.handleCheckProduct.bind(this);
    this.handleCreateButton = this.handleCreateButton.bind(this);
    this.changeNewProductName = this.changeNewProductName.bind(this);
    this.saveProducts = this.saveProducts.bind(this);
  }
  componentWillMount() {
    this.props.getVendorProducts();
  }
  componentDidMount() {
    document.title = 'Products | Prospect Path';
  }
  getTeamId() {
    return parseInt(this.props.currentTeamId);
  }
  getTeam() {
    const teamId = this.getTeamId();
    return this.props.teams.find(team => team.id === teamId)
  }
  productIsSelected(productId) {
    // If the product is in the team then it is selected
    if (this.teamHasProduct(productId)) {
      return true;
    }

    // If the product is in the currently selected products then it is selected
    return this.state.products.includes(productId);
  }
  productIsDisabled(productId) {
    return this.teamHasProduct(productId);
  }
  teamHasProduct(productId) {
    return this.getTeam().products.map(product => product.id).includes(productId);
  }
  handleCreateButton() {
    this.setState({
      createNewProduct: !this.state.createNewProduct,
    });
  }
  handleCheckProduct(productId) {
    // Don't do anything if the product is disabled
    if (this.productIsDisabled(productId)) {
      return;
    }

    if (this.state.products.includes(productId)) {
      this.setState({
        products: this.state.products.filter(selectedProductId => selectedProductId !== productId),
      });
    } else {
      this.setState({
        products: this.state.products.concat([productId]),
      });
    }
  }
  changeNewProductName(event) {
    this.setState({
      newProductName: event.target.value,
    });
  }
  saveProducts() {
    const productIds = this.getTeam().products.map(product => product.id)
      .concat(this.state.products);

    this.props.updateTeamProducts(
      this.getTeamId(),
      productIds,
      this.state.newProductName,
    ).then((response) => {
      if (response.status >=200 && response.status < 300) {
        history.push(`/products`);
      }
    });
  }
  render() {
    if (this.props.user.id === null) {
      return window.location = `/signup/product`;
    }

    const teamId = this.getTeamId();
    const team = this.getTeam();
    if (team === null || team === undefined) {
      return renderLoadingState();
    }

    const products = this.props.vendorProducts.map(product => {
      let productTeamName = '';
      if (product.teams.length > 0) {
        const productTeam = this.props.teams
          .find(currentTeam => currentTeam.id === product.teams[0].id);
        if (productTeam !== undefined) {
          productTeamName = `Managed by ${productTeam.name}`;
        }
      }

      return (
        <ItemListItem key={product.id}>
          <ItemListHeadingContainer>
            <ItemListHeading>
              {product.name}
            </ItemListHeading>
            <ItemListSubheading>
              {productTeamName}
            </ItemListSubheading>
          </ItemListHeadingContainer>
          <ItemListActionContainer onClick={() => this.handleCheckProduct(product.id)}>
            <Checkbox
              disabled={this.productIsDisabled(product.id)}
              checked={this.productIsSelected(product.id)}
            />
          </ItemListActionContainer>
        </ItemListItem>
      );
    });

    let createProduct = '';
    if (this.state.createNewProduct) {
      createProduct = (
        <InputGroup>
          <Label>
            New product name
          </Label>
          <HighlightedInput
            value={this.state.newProductName}
            onChange={this.changeNewProductName}
          />
        </InputGroup>
      );
    }

    return (
      <div>
        <Container>
          <ImageContainer>
            <img src="/images/logo.svg" />
          </ImageContainer>

          <ContainerBody>
            <BackButton style={{cursor:'pointer'}} onClick={() => history.push(`/products`)} />
            <Heading>Manage Products</Heading>
            {products}
            <CreateButton onClick={this.handleCreateButton}>Create New Product</CreateButton>
            {createProduct}
            <Button
              onClick={
                () => {this.saveProducts()}
              }
              style={{ marginTop: '2rem' }}
              block
              color="primary"
            >
              Save
            </Button>
          </ContainerBody>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  currentTeamId: state.teams.currentTeam,
  teams: state.teams.all,
  userTeams: state.teams.userTeams,
  vendorProducts: state.productManagement.vendorProducts,
});
const mapDispatchToProps = dispatch => ({
  getVendorProducts: () => dispatch(getVendorProducts()),
  updateTeamProducts: (teamId, productIds, newProductName) =>
    dispatch(updateTeamProducts(teamId, productIds, newProductName)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TeamProducts));

